import { motion } from "framer-motion";
import { T } from "@/context/ContentContext";

const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 32, className = "", as = "div", ...rest }) {
  const Comp = motion[as];
  return (
    <Comp
      {...rest}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </Comp>
  );
}

export function MaskLines({ lines, className = "", lineClassName = "", delay = 0.15, inView = false }) {
  const trigger = inView
    ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { initial: "hidden", animate: "show" };
  return (
    <motion.span className={`block ${className}`} {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{ hidden: { y: "110%", rotate: 3 }, show: { y: "0%", rotate: 0 } }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}

/** Wraps plain-string lines in editable text when a content key prefix `k` is given. */
export const editableLines = (k, lines) =>
  (Array.isArray(lines) ? lines : [lines]).map((l, i) => (k && typeof l === "string" ? <T k={`${k}.${i}`}>{l}</T> : l));

export function SectionHead({ eyebrow, title, light = false, k, children }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
      <div className="max-w-2xl">
        <Reveal><p className={`eyebrow mb-4 ${light ? "text-gold" : "text-terra"}`}>{k ? <T k={`${k}.eyebrow`}>{eyebrow}</T> : eyebrow}</p></Reveal>
        <h2 className={`text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.03em] leading-[0.95] ${light ? "text-cream" : "text-ink"}`}>
          <MaskLines inView lines={editableLines(k && `${k}.title`, title)} delay={0} />
        </h2>
      </div>
      {children}
    </div>
  );
}
